import { render, staticRenderFns } from "./desig.vue?vue&type=template&id=e15753f6&"
import script from "./desig.vue?vue&type=script&lang=js&"
export * from "./desig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports